var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n\t\t\t\t员工离职-" + _vm._s(_vm.ruleForm.id == null || _vm.ruleForm.id == '' ? '新增' : '修改'))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "540px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "padding": "100px",
      "overflow-x": "hidden"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-weight": "900",
      "font-size": "20px"
    }
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #DADADA",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id == null || _vm.ruleForm.id === ''),
      expression: "ruleForm.id == null || ruleForm.id === ''"
    }],
    on: {
      "click": function($event) {
        return _vm.yglz()
      }
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "40px",
      "width": "80%"
    },
    attrs: {
      "label": "姓名",
      "prop": "staff.staff_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.ruleForm.staff.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "staff_name", $$v)
      },
      expression: "ruleForm.staff.staff_name"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != '' "
    }]
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != '' "
    }],
    staticStyle: {
      "margin-top": "40px",
      "width": "80%"
    },
    attrs: {
      "label": "姓名",
      "prop": "staff.staff_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入姓名",
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.staff.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "staff_name", $$v)
      },
      expression: "ruleForm.staff.staff_name"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "40px",
      "width": "80%"
    },
    attrs: {
      "label": "身份证号"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.staff.staff_card),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "staff_card", $$v)
      },
      expression: "ruleForm.staff.staff_card"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "手机号"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.staff.staff_telephone),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "staff_telephone", $$v)
      },
      expression: "ruleForm.staff.staff_telephone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "入职日期"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.staff.induction_time),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "induction_time", $$v)
      },
      expression: "ruleForm.staff.induction_time"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "组织架构"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.staff.range),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "range", $$v)
      },
      expression: "ruleForm.staff.range"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "城市"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.staff.city_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "city_id", $$v)
      },
      expression: "ruleForm.staff.city_id"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "职位"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.staff.post_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "post_name", $$v)
      },
      expression: "ruleForm.staff.post_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "入职薪酬",
      "prop": "staff.induction_salary"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.ruleForm.induction_salary),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "induction_salary", $$v)
      },
      expression: "ruleForm.induction_salary"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-weight": "900",
      "font-size": "20px"
    }
  }, [_vm._v("| ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("离职信息")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #DADADA",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "label": "离职日期",
      "prop": "quit_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.quit_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "quit_date", $$v)
      },
      expression: "ruleForm.quit_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "label": "离职原因",
      "prop": "dictionaries_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.dictionaries_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "dictionaries_id", $$v)
      },
      expression: "ruleForm.dictionaries_id"
    }
  }, _vm._l((_vm.causeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "离职审批表",
      "prop": "quit_url"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "limit": 1,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handleAvatarSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.ruleForm.quit_url,
      "alt": ""
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "离职提交日期"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "date",
      "disabled": "disabled",
      "value-format": "yyyy-MM-dd",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.quit_time),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "quit_time", $$v)
      },
      expression: "ruleForm.quit_time"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id == null || _vm.ruleForm.id === ''),
      expression: "ruleForm.id == null || ruleForm.id === '' "
    }],
    attrs: {
      "label": "操作人"
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id === null || _vm.ruleForm.id === ''),
      expression: "ruleForm.id === null || ruleForm.id === ''"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.operator),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "operator", $$v)
      },
      expression: "ruleForm.operator"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != '' "
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "操作人"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.operator),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "operator", $$v)
      },
      expression: "ruleForm.operator"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remarks"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.remarks),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "remarks", $$v)
      },
      expression: "ruleForm.remarks"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.StaffChuXianJiLu),
      expression: "StaffChuXianJiLu"
    }],
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-weight": "900",
      "font-size": "20px"
    }
  }, [_vm._v("| ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("保险信息")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #DADADA",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin": "20px 10%"
    },
    attrs: {
      "data": _vm.StaffChuXian,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "保险类型"
    }
  }, [_vm._v(_vm._s(_vm.雇主险))]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "danger_dete",
      "align": "center",
      "label": "出险时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "indemnity_amount",
      "align": "center",
      "label": "赔付金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "settlement_status",
      "align": "center",
      "label": "理赔状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.settlement_status == '0' ? '未理赔' :
          (scope.row.settlement_status == '1' ? '已理赔' : '已撤案')) + "\n\t\t\t\t\t\t\t\t\t\t")]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id == null || _vm.ruleForm.id === ''),
      expression: "ruleForm.id == null || ruleForm.id === '' "
    }],
    staticStyle: {
      "margin-top": "30px",
      "text-align": "center"
    },
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != '' "
    }],
    staticStyle: {
      "margin-top": "30px",
      "text-align": "center"
    },
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "员工离职",
      "visible": _vm.dialogVisible,
      "width": "40%",
      "center": true,
      "close-on-click-modal": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('organizeStaff', {
    ref: "organizeStaff",
    attrs: {
      "type": "radio",
      "accordion": true,
      "staff_id_prop": _vm.object.staff_id
    },
    on: {
      "commit": _vm.saveChange
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['organizeStaff'].commit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-230400ee","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Yglz/Yglz_add.vue
// module id = null
// module chunks = 